module.exports = __webpack_public_path__ + "img/connect-artifacts.5f8bed89.svg";